import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconChipComponent } from '@principle-theorem/ng-principle-shared';

@Component({
  selector: 'pr-query-filter-display',
  templateUrl: './query-filter-display.component.html',
  styleUrls: ['./query-filter-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatTooltip, IconChipComponent],
  host: {
    class: 'inline-block',
  },
})
export class QueryFilterDisplayComponent {
  active = input<boolean>(false);
  label = input<string>('');
  icon = input<string>('filter_alt');
  values = input.required<string>();
}
